export const enum Role {
  Admin = 'admin',
  Instructor = 'instructor',
  Parent = 'parent',
  Applicant = 'applicant',
}

export const enum AdminSubRole {
  President = 'president',
  ChiefOfStaff = 'cos', // chief of staff
  CFO = 'cfo',
  COO = 'coo',
  CMO = 'cmo',
  CAO = 'cao',
  DirectorOfSE = 'dse', // director of student experience
  DirectorOfHR = 'dhr',
  Tech = 'tech',
  /**
   * @deprecated use department chair or department sub-chair instead
   */
  ChapterPresident = 'cp',
  DepartmentChair = 'dc',
  DepartmentSubChair = 'dsc',
}
